<template>
  <div class="song-list">
    <SongCard v-for="song in filteredSongs" :key="song.name" :song="song" />
  </div>
</template>

<style>
  .song-list {
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 7em;
  }
  @media only screen and (min-width: 768px) {
    .song-list {
      grid-template-columns: 1fr 1fr;
    }
  }
</style>

<script>
  import { mapGetters, mapActions } from "vuex";
  import SongCard from "@/components/SongCard";

  export default {
    components: {SongCard},
    mounted() {
      this.ensureSongs();
    },
    computed: {
      ...mapGetters(['filteredSongs'])
    },
    methods: {
      ...mapActions(['ensureSongs'])
    }
  };
</script>
